import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'trackByProp',
	standalone: false
})
export class TrackByPropPipe implements PipeTransform {
	public transform (propName: string) {
		return <T>(_index: number, item: T) => item[propName];
	}
}
